import type { RoutingClassificationResult } from '@/services/editor/AgentChatController';

/**
 * Direct style edits need breakpoint overrides in the serialized editor context
 * so resolver-backed writes can target the winning style layer.
 */
export function shouldIncludeBreakpointStylesForRoute(
  routeClassification: RoutingClassificationResult,
): boolean {
  if (routeClassification.route !== 'visual-editor-stream') {
    return false;
  }

  const metadata = routeClassification.metadata;
  return metadata.complexity === 'simple-style' || metadata.followUpAgent === 'styles';
}
